import { useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { User } from "src/types/user";

import { apiClient } from "../../config/apiClient";
import { API } from "../../config/apiConfig";

export async function getUserSettingsRequest() {
	return await apiClient.get(API.QUERY.USER.SETTINGS).then((res) => res.data);
}

export function useGetUserSettings() {
	return useQuery<User, AxiosError>({
		queryKey: ["user"],
		queryFn: () => getUserSettingsRequest()
	});
}
